/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   avoid using process.env in code, load this module instead.
 */

import { processEnv } from './processEnv'

// On the server, we want to use processEnv to get the real values
// On the browser, processEnv will be empty, and we need to use
// process.env, which has the "baked in" values

interface EnvType {
  NODE_ENV?: string
  API_KEY?: string
  REACT_APP_ENV?: string
  BROWSER?: string
  ZUMPER_MODE?: 'dev' | 'prod'
  APP_PORT?: string
  METRICS_PORT?: string
  BROWSER_WATCH_INTERVAL?: string
}

export const env: EnvType =
  Object.keys(processEnv).length === 0 ? (process.env as EnvType) : (processEnv as EnvType)

export const ON_BROWSER = env.REACT_APP_ENV ? env.REACT_APP_ENV === 'client' : env.BROWSER
export const ON_SERVER = env.REACT_APP_ENV ? env.REACT_APP_ENV === 'server' : !env.BROWSER

export const ZUMPER_MODE = env.ZUMPER_MODE

export const NODE_ENV = env.NODE_ENV
export const IS_PRODUCTION = env.NODE_ENV === 'production'
export const IS_NOT_PRODUCTION = env.NODE_ENV !== 'production'
export const MODE: 'dev' | 'prod' = ZUMPER_MODE === 'prod' ? 'prod' : 'dev'

// server only
export const APP_PORT = env.APP_PORT
export const METRICS_PORT = env.METRICS_PORT
export const DEFAULT_WATCH_INTERVAL = env.BROWSER_WATCH_INTERVAL || 3 * 3600 * 1000
